import { Pipe, PipeTransform } from '@angular/core';
import { formatCpfCnpj } from '@app-utils/document-utils';

@Pipe({
  name: 'cpfcnpj2',
})
export class CpfCNPJPipe implements PipeTransform {
  transform(value: unknown): string {
    if (value == null || value === '') {
      return '';
    }

    return formatCpfCnpj(value);
  }
}
